module.exports = __webpack_public_path__ + "img/avatar1.751e7dbb.png";